import { Navigate, Route, Routes } from "react-router-dom";
import { useSesion } from "./lib/sesion";
import Marco from "./componentes/Marco";
import Inicio from "./paginas/Inicio";
import Legal from "./paginas/Legal";
import Login from "./paginas/Login";
import Registro from "./paginas/Registro";
import PedirPrueba from "./paginas/PedirPrueba";
import Recuperar from "./paginas/Recuperar";
import LibroSocios from "./paginas/LibroSocios";
import Barra from "./paginas/Barra";
import Panel from "./paginas/Panel";
import Socios from "./paginas/Socios";
import SocioNuevo from "./paginas/SocioNuevo";
import SociosImportar from "./paginas/SociosImportar";
import Carnets from "./paginas/Carnets";
import SocioFicha from "./paginas/SocioFicha";
import SocioEditar from "./paginas/SocioEditar";
import Renovaciones from "./paginas/Renovaciones";
import Mostrador from "./paginas/Mostrador";
import Dispensaciones from "./paginas/Dispensaciones";
import Inventario from "./paginas/Inventario";
import Catalogo from "./paginas/Catalogo";
import CatalogoImportar from "./paginas/CatalogoImportar";
import ProductoDetalle from "./paginas/ProductoDetalle";
import Descuentos from "./paginas/Descuentos";
import Comunidad from "./paginas/Comunidad";
import Caja from "./paginas/Caja";
import GastosYCompras from "./paginas/GastosYCompras";
import Contrato from "./paginas/Contrato";
import Cartas from "./paginas/Cartas";
import Cuotas from "./paginas/Cuotas";
import Recuentos from "./paginas/Recuentos";
import Dias from "./paginas/Dias";
import Donaciones from "./paginas/Donaciones";
import Accesos from "./paginas/Accesos";
import Informes from "./paginas/Informes";
import Ajustes from "./paginas/Ajustes";

export default function App() {
  const { usuario, cargando } = useSesion();

  if (cargando) return <div className="cargando">Cargando...</div>;

  /*
   * Sin sesión, la raíz es la web pública y no el formulario de entrar.
   *
   * Quien llega recomendado por otro club necesita saber qué es esto antes de
   * que le pidan usuario y contraseña. Los enlaces profundos (alguien que
   * guardó /socios en favoritos) siguen cayendo en la pantalla de entrar.
   */
  if (!usuario) {
    return (
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/entrar" element={<Login />} />
        <Route path="/aviso-legal" element={<Legal documento="aviso" />} />
        <Route path="/privacidad" element={<Legal documento="privacidad" />} />
        <Route path="/registro" element={<Registro />} />
        <Route path="/prueba" element={<PedirPrueba />} />
        <Route path="/restablecer" element={<Recuperar />} />
        <Route path="/recuperar" element={<Recuperar />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Marco>
      <Routes>
        <Route path="/" element={<Panel />} />
        <Route path="/mostrador" element={<Mostrador />} />
        <Route path="/mostrador/:socioId" element={<Mostrador />} />
        <Route path="/barra" element={<Barra />} />
        <Route path="/socios" element={<Socios />} />
        <Route path="/socios/nuevo" element={<SocioNuevo />} />
        <Route path="/socios/importar" element={<SociosImportar />} />
        <Route path="/socios/libro" element={<LibroSocios />} />
        <Route path="/socios/carnets" element={<Carnets />} />
        <Route path="/socios/:id" element={<SocioFicha />} />
        <Route path="/socios/:id/editar" element={<SocioEditar />} />
        <Route path="/socios/contrato" element={<Contrato />} />
        <Route path="/renovaciones" element={<Renovaciones />} />
        <Route path="/cuotas" element={<Cuotas />} />
        <Route path="/dispensaciones" element={<Dispensaciones />} />
        <Route path="/accesos" element={<Accesos />} />
        <Route path="/catalogo" element={<Catalogo />} />
        <Route path="/catalogo/importar" element={<CatalogoImportar />} />
        <Route path="/catalogo/:id" element={<ProductoDetalle />} />
        <Route path="/descuentos" element={<Descuentos />} />
        <Route path="/comunidad" element={<Comunidad />} />
        <Route path="/inventario" element={<Inventario />} />
        <Route path="/caja" element={<Caja />} />
        {/* Las tres son la misma pantalla, cada una en su pestaña. */}
        <Route path="/gastos" element={<GastosYCompras />} />
        <Route path="/compras" element={<GastosYCompras />} />
        <Route path="/compras/proveedores" element={<GastosYCompras />} />
        <Route path="/donaciones" element={<Donaciones />} />
        <Route path="/recuentos" element={<Recuentos />} />
        <Route path="/dias" element={<Dias />} />
        <Route path="/informes" element={<Informes />} />
        <Route path="/cartas" element={<Cartas />} />
        <Route path="/ajustes" element={<Ajustes />} />
        {/* Tambien con sesion abierta: un documento legal no puede depender
            de haber cerrado la sesion para poder leerse. */}
        <Route path="/aviso-legal" element={<Legal documento="aviso" />} />
        <Route path="/privacidad" element={<Legal documento="privacidad" />} />
        <Route path="/prueba" element={<PedirPrueba />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Marco>
  );
}
